import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useState } from "react";

import EducationModalComponent from "./EducationModalComponent";
import protectedAxios from "../../../common/axios";
import { API_URL } from "../../../common/constants";

export default function EducationModalContainer({
  showEducationModal,
  setShowEducationModal,
  validEctsValues,
}) {
  const [selectedProgram, setSelectedProgram] = useState(null);
  const [isAddNewVisible, setIsAddNewVisible] = useState(true);

  useEffect(() => {
    setIsAddNewVisible(true);
  }, [showEducationModal]);

  const loggedInUserProfile = useSelector(
    (state) => state.user?.gamePlayerProfile
  );
  const associatedPrograms = loggedInUserProfile.associatedPrograms;
  const domesticPrograms = loggedInUserProfile.domesticPrograms;

  const onSuccess = () => {
    toast.success("Score Saved successfully!");
  };
  const onFailure = () => {
    toast.error("Failed to Save Score!");
  };

  const saveToProfile = () => {
    const payload = {
      programId: selectedProgram._id,
      lectureHours: validEctsValues.lectureHours,
      selfStudyHours: validEctsValues.selfStudyHours,
      weeks: validEctsValues.weeks,
    };

    protectedAxios
      .post(`${API_URL}/v1/ects/save-score`, payload)
      .then(() => {
        onSuccess();
      })
      .catch(() => {
        onFailure();
      });
    setSelectedProgram(null);
    setShowEducationModal(!showEducationModal);
  };

  const programsExists = () => {
    if (
      associatedPrograms?.alumnus?.length !== 0 ||
      associatedPrograms?.enrolled?.length !== 0 ||
      domesticPrograms?.alumnus?.length !== 0 ||
      domesticPrograms?.enrolled?.length !== 0
    )
      return true;
    return false;
  };

  return (
    showEducationModal && (
      <EducationModalComponent
        selectedProgram={selectedProgram}
        setSelectedProgram={setSelectedProgram}
        isAddNewVisible={isAddNewVisible}
        setIsAddNewVisible={setIsAddNewVisible}
        associatedPrograms={associatedPrograms}
        domesticPrograms={domesticPrograms}
        saveToProfile={saveToProfile}
        showEducationModal={showEducationModal}
        setShowEducationModal={setShowEducationModal}
        programsExists={programsExists}
      />
    )
  );
}
